module.exports = __webpack_public_path__ + "static/media/imageD.47067658.png";